"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionSettingsSchema = void 0;
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const yup = __importStar(require("yup"));
const ROUNDING_METHOD_REQUIRED = "Please select a default rounding method";
const TAX_RESIDENCY_REQUIRED = "Please select a fund tax residency country";
const TAX_RESIDENCY_INVALID = "Please select a valid fund tax residency country";
const INVESTOR_TREATMENT_REQUIRED = "Please select an investor treatment";
const roundingMethodValues = Object.values(mystake_common_sdk_1.RoundingMethod);
const investorTreatmentValues = Object.values(mystake_common_sdk_1.InvestorTreatment);
exports.DistributionSettingsSchema = yup.object().shape({
    allowReinvestment: yup.boolean().required("Please select whether reinvestment is allowed"),
    roundingMethod: yup
        .string()
        .trim(ROUNDING_METHOD_REQUIRED)
        .required(ROUNDING_METHOD_REQUIRED)
        .oneOf(roundingMethodValues, ROUNDING_METHOD_REQUIRED),
    taxResidencyCountryCode: yup
        .string()
        .trim(TAX_RESIDENCY_REQUIRED)
        .required(TAX_RESIDENCY_REQUIRED)
        .uppercase()
        .length(3, TAX_RESIDENCY_INVALID)
        .test("valid-alpha3", TAX_RESIDENCY_INVALID, (value) => Boolean(value && mystake_common_sdk_1.COUNTRY_ALPHA3_CODES.has(value))),
    investorTreatment: yup
        .string()
        .trim(INVESTOR_TREATMENT_REQUIRED)
        .required(INVESTOR_TREATMENT_REQUIRED)
        .oneOf(investorTreatmentValues, INVESTOR_TREATMENT_REQUIRED),
});
//# sourceMappingURL=DistributionSettingsSchema.js.map